module.exports = __webpack_public_path__ + "static/media/25.88066e92.jpg";